export default {
    /** 주문모달 출력 여부 */
    isOpenModalOrderInfo: 0,
};
